/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  /*ADD_ITEM(state, item) {
    state.users.unshift(item)
  },
  SET_USERS(state, users) {
    state.users = users
  },
  SET_CLASSES(state, classes) {
    state.classes = classes
  },
  REMOVE_RECORD(state, itemId) {
      const userIndex = state.users.findIndex((u) => u.id == itemId)
      state.users.splice(userIndex, 1)
  },
  UPDATE_USERS(state, user) {
    const eventIndex = state.users.findIndex((e) => e.id == user.id)
    Object.assign(state.users[eventIndex], user)
},*/
SET_STAT_DOMAINE(state, domaine) {
  state.domaines_f_s = domaine
},
SET_STAT_CLASSE(state, classe) {
  state.classes_f_s = classe
},
SET_STAT_FORMATION(state, formation) {
  state.formations_f_s = formation
},
SET_CANDIDATS(state, candidats) {
  state.candidats = candidats
},
SET_FORMATEURS(state, formateurs) {
  state.formateurs = formateurs
},
SET_FORMATIONS(state, formations) {
  state.formations = formations
},
SET_FORMATEURS_SA(state, salaire_formateur) {
  state.salaire_formateur = salaire_formateur
},
SET_DOMAINES(state, domaines) {
  state.domaines = domaines
},
SET_GAINS(state, gains) {
  state.gains = gains
},
SET_PARTICIPATION(state, participations) {
  state.participations = participations
},
SET_PARTICIPATIONFORMATION(state, participationsFormations) {
  state.participationsFormations = participationsFormations
},
SET_PARTICIPATIONDOMAINE(state, participationsDomaines) {
  state.participationsDomaines = participationsDomaines
},
SET_GAINFORMATION(state, GainsFormations) {
  state.GainsFormations = GainsFormations
},
SET_GAINDOMAINE(state, GainsDomaines) {
  state.GainsDomaines = GainsDomaines
},
SET_GAINANNUELLE(state, GainsanneeFormations) {
  state.GainsanneeFormations = GainsanneeFormations
},


}
